/**
 * Dark Theme — production dark theme definition.
 */

import type { Theme } from "./types";

export const darkTheme: Theme = {
  name: "dark",

  colors: {
    text: {
      primary: "#e0e2e6",
      secondary: "#9ba1ab",
      muted: "#6b7280",
      disabled: "#555d6a",
      onDark: "#ffffff",
      link: "#6ba3e0",
      content: "#6ba3e0",
    },
    surface: {
      page: "#1a1d23",
      raised: "#2a2f38",
      muted: "#2e333c",
      panel: "#24272e",
      controls: "#22262e",
      input: "#22262e",
      white: "#22262e",
      overlay: "rgba(0, 0, 0, 0.6)",
      subtle: "rgba(90, 111, 140, 0.15)",
      subtleHover: "rgba(90, 111, 140, 0.3)",
      highlight: "rgba(69, 194, 239, 0.1)",
      selected: "rgba(186, 198, 209, 0.25)",
      hover: "rgba(255, 255, 255, 0.08)",
      disabled: "#2e333c",
    },
    border: {
      default: "#3a3f4a",
      subtle: "#333842",
      strong: "#555d6a",
      divider: "#3a4050",
      control: "#b0b6be",
      focus: "#6ba3e0",
    },
    interactive: {
      default: "#5d8ab5",
      hover: "#3a5570",
      muted: "#404850",
    },
    status: {
      success: "#4caf50",
      error: "#ef5350",
      errorDark: "#e53935",
      gold: "#D1B656",
      goldHover: "#e8c060",
    },
    brand: {
      dark: "#5d8ab5",
      light: "#5ea8c9",
      accent: "#45c2ef",
    },
    nav: {
      background: "#111318",
      surface: "#1a1e26",
      secondary: "rgb(90, 130, 180)",
      hover: "#252a34",
    },
    footer: {
      bg: "#7b94b0",
    },
  },

  shadow: {
    none: "none",
    sm: "0 1px 3px rgba(0, 0, 0, 0.3)",
    base: "0px 0px 5px 0px rgba(0, 0, 0, 0.4)",
    md: "0px 2px 15px rgba(0, 0, 0, 0.5)",
    lg: "0 0 9px 1px rgba(0, 0, 0, 0.5)",
  },
};
